import type { EdgeLabelsOptions } from '../edges';
import type { LinePattern } from '../edges/EdgeStyle';
import type {
  EdgeCenterLabel,
  EdgeLinecapLabel,
  PathLookupEdgeType,
  ProtocolEdgeType,
} from '../edges/constants';

export type TopologyEdgeSettingsId = string;
export type GroupEdgeSettingsId = string;
export type PathLookupEdgeSettingsId = string;

export interface BaseEdgeSettings {
  grouped: boolean;
  labels: (EdgeCenterLabel | EdgeLinecapLabel)[];
  labelsOptions?: EdgeLabelsOptions;
  style: GraphEdgeSettingsStyle;
  visible: boolean; // default `true`
}

export type GraphEdgeSettingsStyle = {
  color: string; // #rrggbb
  pattern: LinePattern;
  // number of edges in group: thin, medium, thick line
  thicknessThresholds: [number, number, number];
};

export interface TopologyEdgeSettings extends BaseEdgeSettings {
  id: TopologyEdgeSettingsId;
  name: ProtocolEdgeType;
  type: 'protocol';
}

export interface PathLookupEdgeSettings extends BaseEdgeSettings {
  id: PathLookupEdgeSettingsId;
  name: PathLookupEdgeType;
  type: 'pathLookupEdge';
}

export interface GroupEdgeSettings {
  // It is possible that in the future we'll have topology edges added by user to a path lookup graph,
  // therefore group edges intentionally allow mixing edge types
  children: (TopologyEdgeSettings | PathLookupEdgeSettings)[];
  grouped: boolean; // default `true`
  id: GroupEdgeSettingsId;
  label: string; // defaults to `name` value
  name: string;
  style: GraphEdgeSettingsStyle;
  type: 'group';
  visible: boolean;
  labelsOptions?: EdgeLabelsOptions;
}
